var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeader1 = function SvgHeader1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.857-6.188v115.913c77.503 45.107 244.653 165.886 535.153 153.14 290.481-12.752 291.117-170.37 918.474-39.445V-6.185L-5.857-6.188Z",
    fill: "#AFB8F0"
  })));
};

export default SvgHeader1;